import * as types from '../constants/actionTypes';

export function toggleGamesStatusFilter(statuses) {
  return {
    type: types.TOGGLE_PLAYERLIST_GAMES_STATUS_FILTER,
    statuses
  };
}

export function toggleGamesFilter(gameId) {
  return {
    type: types.TOGGLE_PLAYERLIST_GAMES_FILTER,
    gameId
  };
}

export function toggleTeamsFilter(teamId) {
  return {
    type: types.TOGGLE_PLAYERLIST_TEAMS_FILTER,
    teamId
  };
}

export function toggleSelectedTeamsFilter(teamId) {
  return {
    type: types.TOGGLE_PLAYERLIST_SELECTED_TEAMS_FILTER,
    teamId
  };
}

export function toggleAutoAdvancePositionsFilter() {
  return {
    type: types.TOGGLE_AUTO_ADVANCE_POSITIONS_FILTER
  };
}

export function toggleProjectedScoreFilter() {
  return {
    type: types.TOGGLE_PROJECTED_SCORE_FILTER
  };
}

export function setSortField(sortField) {
  return {
    type: types.SET_PLAYERLIST_SORT,
    sortField
  };
}

export function resetFilters() {
  return {
    type: types.RESET_PLAYERLIST_FILTERS
  };
}

export function searchPlayersList(value) {
  return {
    type: types.SEARCH_PLAYERS_LIST,
    searchTerm: value
  };
}

export function clearSearch() {
  return {
    type: types.CLEAR_SEARCH
  };
}

export function setPlayerTypeFilter(value) {
  return {
    type: types.SET_PLAYER_TYPE_FILTER,
    value
  };
}
